import { AnyAction, CombinedState, combineReducers, PayloadAction, Reducer } from "@reduxjs/toolkit";

import { configureStore } from '@reduxjs/toolkit';
import logger from 'redux-logger';

import reducer, { RootStates } from './modules';
import { TypedUseSelectorHook, useSelector, useDispatch } from "react-redux";

const store = configureStore({ 
  reducer: reducer as Reducer<CombinedState<RootStates>,AnyAction>,
  middleware: (getDefaultMiddleware) => process.env.REACT_APP_MODE !== 'production' ? getDefaultMiddleware().concat(logger as any) : getDefaultMiddleware(),
  devTools: process.env.REACT_APP_MODE !== 'production',
});

export default store

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

export const useAppDispatch: () => AppDispatch = useDispatch
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector